export default "<p>Loading...</p>\n";